module.exports = __webpack_public_path__ + "static/media/black-t-shirt.b831ca4a.jpg";